export interface TripDay {
    id: number;
    title: string;
    coordinates: [number, number];
    description: string;
  }
  
  export interface City {
    id: number;
    cityname: string;
    country_code: string;
    coordinates: [number, number];
    iata_city_code: string | null;
  }
  
  export type TransportMode = "flight" | "train" | "bus" | "ferry" | "car" | "ground";

  export type TransportModeCode = 1 | 2 | 3 | 4 | 5; // exemple: 1 = vol, 2 = train, 3 = bus
  
  export interface TripTransport {
    origin: number;
    destination: number;
    transport_mode: TransportMode[];
    trip_day_id: number;
  }
  
  export interface HotelNights {
    location: number; // city ID
    trip_day_ids: number[];
  }
  
  export interface RentalCar{
    pickup_location_id: number;
    dropoff_location_id: number;
    trip_day_ids: number[];
  }

  export interface ItineraryData {
    title: string;
    trip_days: TripDay[];
    arrive_city: number;
    return_city: number;
    images?: any;
    is_new?: boolean;
    departure_date?: string;
    departure_city?: string;
    cities?: City[];
    transports?: TripTransport[];
    rental_car?: RentalCar[];
    hotel_cities?: HotelNights[];
  }

export interface Itinerary {
    created_at: string | null;
    data: ItineraryData,
    uuid: string | null;
    title: string | null;
    description: string | null;
    version?: number;
    message?: Message;
  }

export interface Conversation {
  created_at: string;
  title: string;
  data: any;
  uuid: string;
}


export interface FlightSearchParams {
  origin: string;
  destination: string;
  departure_date: string;
  return_date?: string;
  adults?: number;
  children?: number;
  infants?: number;
}

export interface SearchResponseResults {
  outbound: TransportItem[];
  inbound: TransportItem[];
  error?: string;
}


export interface SearchResponse {
  results: SearchResponseResults;
  params: any;
  agent_id?: number;
}

export type TransportItem = {
  id: string;
  A: number; //price
  C: string; //currency
  arr: string; //arrival time "2025-06-15T19:20:00"
  bd?: string[];
  ch: number; // number of changes
  cie: number; //company name
  cpd?: any; //company logo
  dep: string; //departure time "2025-06-15T19:20:00"
  du: number; // duration in minutes
  modes: TransportModeCode[];
  nf: string; //departure airport
  nt: string; // arrival airport
  segments?: Segment[];
  availability?: number;
  agent_id?: number;
};

export type Carrier = {
  number: string;
  n: string;
  img: string;
  id: number;
};

export type Segment = {
  dep: string;
  arr: string;
  du: number;
  nf: string;
  nt: string;
  ch_time: number | null;
  mode: TransportModeCode;
  info: Carrier;
};

export interface TransportSearchParams {
  mode: string;
  origin: string;
  destination: string;
  origin_coordinates: string;
  destination_coordinates: string;
  origin_country_code?: string;
  destination_country_code?: string;
  departure_date: string;
  return_date?: string;
  adults?: number;
  children?: number;
  infants?: number;
  agent_id?: number;
}

export type Weights = {
  price: number;
  duration: number;
  efficiency: number;
};

export type ScoredFlight = TransportItem & {
  efficiency: number;
  totalScore: number;
  labels: string[];
};


export type Message = {
  role: string;
  intent?: string | null;
  content: string;
  timestamp: number;
  parsed?: any;
  conversation_uuid?: string;
  uuid?: string;
  itineraries?: Itinerary[];
  conversation?: Conversation;
};

export interface HotelSearchParams {
    id?: number;
    location: City;
    type?: string;
    checkin_date: string;
    checkout_date: string;
    number_adults?: number;
    number_children?: number;
    number_rooms?: number;
};


export interface CarHireSearchParams {
    id?: number,
    pickup_city: City,
    dropoff_city: City,
    pickup_date: string,
    dropoff_date: string,
};


export const ChatActionType = {
  CHAT: "chat",
  ITINERARY: "itinerary",
  SEARCH: "search",
};

export interface TransportSearch {
  id: number;
  origin: City;
  destination: City;
  departure_date: string;
  return_date?: string;
  distance?: number;
  transport_mode: TransportMode[];
}